module.exports = __webpack_public_path__ + "img/Arcane_Thumb.c644fa0f.webp";